const rights = document.getElementById('RightsText')?.value;

const elementsFunct = [];

const elementsdep = [];


const area = document.getElementById('area');


const funct = document.getElementById('function');


const department = document.getElementById('D');


const arrRights = rights?.split('_');

if (arrRights) {

    switch (arrRights.length) {
        case 1:
            HideElementsFunct(funct);
            HideElementsDepartment(department);
            break;

        case 2:
            area.selectedIndex = "1";
            area.disabled = true;
            HideElementsFunct(funct);
            HideElementsDepartment(department);
            ShowElementsByRightsFunction(rights);
            break;
        case 3:

            area.selectedIndex = "1";
            area.disabled = true;
            funct.selectedIndex = "1";
            funct.disabled = true;
            break;
        case 4:
            area.selectedIndex = "1";
            area.disabled = true;
            funct.selectedIndex = "1";
            funct.disabled = true;
            department.selectedIndex = 1;
            break;
    }
}

if (area) {
    area.addEventListener('change', function () {
        funct.innerText = "Välj verksamhet";
        department.innerText = "Välj avdelning";

        // Rensa nuvarande options men spara tillbaka "Välj verksamhet"
        funct.options.length = 0;
        const defaultFunctOption = document.createElement("option");
        defaultFunctOption.value = "";
        defaultFunctOption.textContent = "Välj verksamhet";
        funct.add(defaultFunctOption);

        department.options.length = 0;
        const defaultDepOption = document.createElement("option");
        defaultDepOption.value = "";
        defaultDepOption.textContent = "Välj avdelning";
        department.add(defaultDepOption);

        for (var i = 0; i < elementsFunct.length; i++) {
            var element = elementsFunct[i].value;

            if (element === "") continue; // hoppa över tomma

            var elementSplit = element.split('_')[0] + '_' + element.split('_')[1];
            if (elementSplit === this.value) {
                funct.add(elementsFunct[i]);
            }
        }

        // se till att första alternativet ("Välj verksamhet") är valt
        funct.selectedIndex = 0;
        department.selectedIndex = 0;
    });
}


if (funct) {
    funct.addEventListener('change', function () {
        department.innerText = "Välj avdelning";

        for (var i = 0; i < elementsdep.length; i++) {
            var element = elementsdep[i].value;

            if (element === "") {
                department.add(elementsdep[i]);
            }
            else {
                var splitted = element.split('_');

                var compareObj = splitted[0] + '_' + splitted[1] + '_' + splitted[2];
                if (compareObj === this.value) {
                    department.add(elementsdep[i]);
                }
            }
        }
    });
}

function HideElementsFunct(arr) {
    for (var i = 0; i < arr.options.length; i++) {
        elementsFunct.push(arr.options[i]);
    }
    arr.innerText = null;
}

function HideElementsDepartment(arr, rights) {
    for (var i = 0; i < arr.options.length; i++) {
        elementsdep.push(arr.options[i]);
    }
    arr.innerText = null;
}

function ShowElementsByRightsFunction(rights) {
    for (var i = 0; i < elementsFunct.length; i++) {
        var element = elementsFunct[i].value;

        if (element === "") {
            funct.add(elementsFunct[i]);
        }
        else {
            var splitted = element.split('_');

            var compareObj = splitted[0] + '_' + splitted[1];
            if (compareObj === rights) {
                funct.add(elementsFunct[i]);
            }
        }
    }
}

function ShowElementsByRightsDepartment(rights) {
    for (var i = 0; i < elementsdep.length; i++) {
        var element = elementsdep[i].value;

        if (element === "") {
            department.add(elementsdep[i]);
        }
        else {
            var splitted = element.split('_');

            var compareObj = splitted[0] + '_' + splitted[1];
            if (compareObj === rights) {
                department.add(elementsdep[i]);
            }
        }
    }
}